const PENDING_JOB_VIEW_KEY = "tema_pending_job_view";

export function setPendingJobView({ jobId, toolId, request }) {
  try {
    sessionStorage.setItem(
      PENDING_JOB_VIEW_KEY,
      JSON.stringify({ jobId, toolId, request }),
    );
  } catch {
    // ignore
  }
}

export function consumePendingJobView(toolId) {
  try {
    const raw = sessionStorage.getItem(PENDING_JOB_VIEW_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    if (parsed?.toolId && parsed.toolId !== toolId) {
      return null;
    }
    sessionStorage.removeItem(PENDING_JOB_VIEW_KEY);
    return parsed;
  } catch {
    return null;
  }
}
